import { render, staticRenderFns } from "./step-type.vue?vue&type=template&id=96b551b6&"
import script from "./step-type.vue?vue&type=script&lang=js&"
export * from "./step-type.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports